var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('Fire',{attrs:{"level":_vm.fireLevel}}),(_vm.isBreaking)?_c('Coffee'):_vm._e(),_c('PC'),_c('AvatarIcon',{attrs:{"userId":_vm.userId,"tablePosition":_vm.tablePosition,"breaking":_vm.isBreaking}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }